/*
 * Copyright (c) 2020. Sanish Manandhar
 * All Rights Reserved
 */

// Import actionType constants
import {
  INVOICE_UPSERT_REQUEST,
  INVOICE_UPSERT_REQUEST_SUCCESS,
  INVOICE_UPSERT_REQUEST_FAILURE,
  INVOICE_FETCH_REQUEST,
  INVOICE_FETCH_REQUEST_SUCCESS,
  INVOICE_FETCH_REQUEST_FAILURE,
  SINGLE_INVOICE_FETCH_REQUEST,
  SINGLE_INVOICE_FETCH_REQUEST_SUCCESS,
  SINGLE_INVOICE_FETCH_REQUEST_FAILURE,
  INVOICE_VOID_REQUEST,
  INVOICE_VOID_REQUEST_SUCCESS,
  INVOICE_VOID_REQUEST_FAILURE,
  SINGLE_INVOICE_UPDATE_REQUEST,
  SINGLE_INVOICE_UPDATE_REQUEST_SUCCESS,
  SINGLE_INVOICE_UPDATE_REQUEST_FAILURE,
  INVOICE_FETCH_TAX_REQUEST,
  INVOICE_FETCH_TAX_REQUEST_SUCCESS,
  INVOICE_FETCH_TAX_REQUEST_FAILURE,
  INVOICE_TEMPLATE_FETCH_REQUEST,
  INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST,
  INVOICE_TEMPLATE_UPSERT_REQUEST,
  INVOICE_TEMPLATE_FETCH_REQUEST_SUCCESS,
  INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_SUCCESS,
  INVOICE_TEMPLATE_UPSERT_REQUEST_SUCCESS,
  INVOICE_TEMPLATE_FETCH_REQUEST_FAILURE,
  INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_FAILURE,
  INVOICE_TEMPLATE_UPSERT_REQUEST_FAILURE,
  INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST,
  INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS,
  INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE,
  CLIENT_INVOICE_FETCH_REQUEST,
  CLIENT_INVOICE_FETCH_REQUEST_SUCCESS,
  CLIENT_INVOICE_FETCH_REQUEST_FAILURE,
  INVOICE_UNPAID_COUNT_FETCH_REQUEST,
  INVOICE_UNPAID_COUNT_FETCH_REQUEST_SUCCESS,
  INVOICE_UNPAID_COUNT_FETCH_REQUEST_FAILURE,
  CLEAN_INVOICE_ERROR_PROPS,
  CLEAN_INVOICE_LIST_PROPS,
  CLEAN_SINGLE_INVOICE_PROPS,
  INVOICE_PAYMENT_MODE_FETCH_REQUEST,
  INVOICE_PAYMENT_MODE_FETCH_REQUEST_SUCCESS,
  INVOICE_PAYMENT_MODE_FETCH_REQUEST_FAILURE,
  INVOICE_STATUS_FETCH_REQUEST,
  INVOICE_STATUS_FETCH_REQUEST_SUCCESS,
  INVOICE_STATUS_FETCH_REQUEST_FAILURE,
  INVOICE_SYNC_REQUEST,
  INVOICE_SYNC_REQUEST_SUCCESS,
  INVOICE_SYNC_REQUEST_FAILURE,
  INVOICE_CHART_DATA_REQUEST,
  INVOICE_CHART_DATA_REQUEST_SUCCESS,
  INVOICE_CHART_DATA_REQUEST_FAILURE,
  CLEAN_INVOICE_TEMPLATE_PROPS,
  INVOICE_NOTIFICATION_RESEND,
  INVOICE_NOTIFICATION_RESEND_SUCCESS,
  INVOICE_NOTIFICATION_RESEND_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  taxPayload: [],
  taxLoading: false,
  taxErrors: {},
  dropdown: [],
  dropdownLoading: false,
  dropdownErrors: {},
  invoiceUnpaidCountPayload: [],
  invoiceUnpaidCountLoading: false,
  invoiceUnpaidCountErrors: {},
  invoiceUpdateLoading: false,
  invoiceUpdatePayload: [],
  invoiceUpdateErrors: {},
  invoicePaymentModeLoading: false,
  invoicePaymentModePayload: [],
  invoicePaymentModeErrors: {},
  invoiceStatusLoading: false,
  invoiceStatusPayload: [],
  invoiceStatusErrors: {},
  invoiceSync: [],
  invoiceSyncLoading: false,
  invoiceSyncErrors: {},
  invoiceChartData: [],
  invoiceChartDataLoading: false,
  invoiceChartDataErrors: {},
  invoiceTemplateItemsPayload: [],
  invoiceTemplateItemsLoading: false,
  invoiceTemplateItemsError: {},
  invoiceNotificationResendPayload: [],
  invoiceNotificationResendPayloadLoading: false,
  invoiceNotificationResendPayloadErrors: {},
};

const invoiceReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case INVOICE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case INVOICE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case INVOICE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case INVOICE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case INVOICE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.invoiceInfos.currentPage,
          pageSize: action.data.invoiceInfos.limit,
          total: action.data.invoiceInfos.totalRecords,
          totalPage:
            Math.round(action.data.invoiceInfos.totalRecords / action.data.invoiceInfos.limit) +
            (Math.abs(action.data.invoiceInfos.totalRecords / action.data.invoiceInfos.limit) >
            Math.round(action.data.invoiceInfos.totalRecords / action.data.invoiceInfos.limit)
              ? 1
              : 0),
        },
      });

    case INVOICE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_INVOICE_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_INVOICE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case SINGLE_INVOICE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case INVOICE_VOID_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case INVOICE_VOID_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case INVOICE_VOID_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_INVOICE_UPDATE_REQUEST:
      return Object.assign({}, state, {
        invoiceUpdateLoading: true,
      });

    case SINGLE_INVOICE_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceUpdateLoading: false,
        invoiceUpdatePayload: action.data,
        invoiceUpdateErrors: {},
      });

    case SINGLE_INVOICE_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceUpdateLoading: false,
        invoiceUpdateErrors: action.error,
      });

    case INVOICE_FETCH_TAX_REQUEST:
      return Object.assign({}, state, {
        taxLoading: true,
      });

    case INVOICE_FETCH_TAX_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxLoading: false,
        taxPayload: action.data,
        taxErrors: {},
      });

    case INVOICE_FETCH_TAX_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxLoading: false,
        taxErrors: action.error,
      });

    case CLIENT_INVOICE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CLIENT_INVOICE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case CLIENT_INVOICE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case INVOICE_UNPAID_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        invoiceUnpaidCountLoading: true,
      });

    case INVOICE_UNPAID_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceUnpaidCountLoading: false,
        invoiceUnpaidCountPayload: action.data,
        invoiceUnpaidCountErrors: {},
      });

    case INVOICE_UNPAID_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceUnpaidCountLoading: false,
        invoiceUnpaidCountErrors: action.error,
      });

    case INVOICE_PAYMENT_MODE_FETCH_REQUEST:
      return Object.assign({}, state, {
        invoicePaymentModeLoading: true,
      });

    case INVOICE_PAYMENT_MODE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoicePaymentModeLoading: false,
        invoicePaymentModePayload: action.data,
        invoicePaymentModeErrors: {},
      });

    case INVOICE_PAYMENT_MODE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoicePaymentModeLoading: false,
        invoicePaymentModeErrors: action.error,
      });

    case INVOICE_STATUS_FETCH_REQUEST:
      return Object.assign({}, state, {
        invoiceStatusLoading: true,
      });

    case INVOICE_STATUS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceStatusLoading: false,
        invoiceStatusPayload: action.data,
        invoiceStatusErrors: {},
      });

    case INVOICE_STATUS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceStatusLoading: false,
        invoiceStatusErrors: action.error,
      });

    case CLEAN_INVOICE_ERROR_PROPS:
      return Object.assign({}, state, {
        invoiceUpdateErrors: {},
        errors: {},
        singleErrors: {},
        taxErrors: {},
        invoiceUnpaidCountErrors: {},
        dropdownErrors: {},
        invoiceChartDataErrors: {},
      });

    case CLEAN_INVOICE_LIST_PROPS:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        invoiceChartData: [],
        invoiceChartDataLoading: false,
      });

    case CLEAN_SINGLE_INVOICE_PROPS:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: {},
      });

    case INVOICE_SYNC_REQUEST:
      return Object.assign({}, state, {
        invoiceSyncLoading: true,
      });

    case INVOICE_SYNC_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceSyncLoading: false,
        invoiceSync: action.data,
        invoiceSyncErrors: {},
      });

    case INVOICE_SYNC_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceSyncLoading: false,
        invoiceSyncErrors: action.error,
      });

    case INVOICE_CHART_DATA_REQUEST:
      return Object.assign({}, state, {
        invoiceChartDataLoading: true,
      });

    case INVOICE_CHART_DATA_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceChartDataLoading: false,
        invoiceChartData: action.data,
        invoiceChartDataErrors: {},
      });

    case INVOICE_CHART_DATA_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceChartDataLoading: false,
        invoiceChartDataErrors: action.error,
      });

    default:
      return state;
  }
};

export default invoiceReducer;

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const invoiceTemplateReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case INVOICE_TEMPLATE_FETCH_REQUEST:
    case INVOICE_TEMPLATE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case INVOICE_TEMPLATE_FETCH_REQUEST_SUCCESS:
    case INVOICE_TEMPLATE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case INVOICE_TEMPLATE_FETCH_REQUEST_FAILURE:
    case INVOICE_TEMPLATE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST:
      return Object.assign({}, state, {
        dropdownLoading: true,
      });

    case INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        dropdown: action.data,
        dropdownLoading: false,
        dropdownErrors: {},
      });

    case INVOICE_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        dropdownLoading: false,
        dropdownErrors: action.error,
      });

    case INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST:
      return Object.assign({}, state, {
        invoiceTemplateItemsLoading: true,
      });

    case INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceTemplateItemsPayload: action.data,
        invoiceTemplateItemsLoading: false,
        invoiceTemplateItemsError: {},
      });

    case INVOICE_TEMPLATE_ITEMS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceTemplateItemsLoading: false,
        invoiceTemplateItemsError: action.error,
      });

    case CLEAN_INVOICE_TEMPLATE_PROPS:
      return Object.assign({}, state, {
        invoiceTemplateItemsPayload: [],
        errors: {},
        invoiceTemplateItemsError: {},
      });

    case INVOICE_NOTIFICATION_RESEND:
      return Object.assign({}, state, {
        invoiceNotificationResendPayloadLoading: true,
      });

    case INVOICE_NOTIFICATION_RESEND_SUCCESS:
      return Object.assign({}, state, {
        invoiceNotificationResendPayload: action.data,
        invoiceNotificationResendPayloadLoading: false,
        invoiceNotificationResendPayloadErrors: {},
      });

    case INVOICE_NOTIFICATION_RESEND_FAILURE:
      return Object.assign({}, state, {
        invoiceNotificationResendPayloadLoading: false,
        invoiceNotificationResendPayloadErrors: action.error,
      });

    default:
      return state;
  }
};
